<template>
    <Card :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`" :modifiers="`py-5`">
        <template slot="card-header">
            <h1 v-translate>Password Reset</h1>
        </template>
        <template slot="card-body">
            <form method="POST" :action="$laraRoute('password.reset')" @submit.prevent="handleForm" aria-label="Reset Password" novalidate>
                <div
                    class="form-group row justify-content-center align-items-start"
                    v-if="!isSmartCharts"
                >
                    <p
                        class="text-standard"
                        v-translate
                    >This will reset your SmartCharts account password at the same time.</p>
                </div>

                <PasswordHandler :reset="true"/>

                <div class="form-group row justify-content-center mt-4 mb-0">
                    <div class="col-md-6 text-center">
                        <LoaderedButton
                            type="submit"
                            btnClasses="btn btn-primary btn--2x"
                            :content="'Reset Password' | translate"
                            :isValid="isValid"
                        />
                    </div>
                </div>
            </form>
        </template>
    </Card>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import FlashMessage from '@C/FlashMessage';
import Card from '@C/Card.vue';
import PasswordHandler from '@C/PasswordHandler';
import LoaderedButton from '@C/LoaderedButton';

import validator from '@M/validationWrapper';

export default {
    name: 'PasswordReset',
    beforeMount() {
        // Store the querystring email address into the vuex state
        this.$store.commit(
            'Auth/email',
            decodeURIComponent(this.$route.query.email)
        );
    },
    computed: {
        isSmartCharts: function () {
            return window.isSmartCharts;
        },
    },
    methods: {
        ...mapActions('Auth', ['passwordReset']),
        formHandler() {
            this.passwordReset().catch(this.handleOuterErrors);
        }
    },
    components: {
        Card,
        PasswordHandler,
        FlashMessage,
        LoaderedButton
    },
    mixins: [validator]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/PasswordReset.vue